import { forwardRef, useId } from "react";
import Container from "../Container";
import * as S from "./styles";

type Props = {
  label?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
};

const CustomCheckbox = forwardRef<HTMLInputElement, Props>(
  ({ onChange, checked, label, disabled, indeterminate }, ref) => {
    // The label text renders outside CheckboxWrapper, so it needs an explicit
    // for/id pair; otherwise only the small box toggles the checkbox.
    const inputId = useId();

    return (
      <Container padding="0" gap={1} flat>
        <S.CheckboxWrapper className={disabled ? "disabled" : ""}>
          <S.CheckboxInput
            ref={ref}
            id={inputId}
            type="checkbox"
            onChange={onChange}
            checked={checked}
            disabled={disabled}
            data-indeterminate={indeterminate}
          />
          <S.Checkmark>
            <S.CheckmarkTick />
            <S.CheckmarkIndeterminate />
          </S.Checkmark>
        </S.CheckboxWrapper>
        {label && (
          <S.CheckboxLabel
            htmlFor={inputId}
            className={disabled ? "disabled" : ""}>
            {label}
          </S.CheckboxLabel>
        )}
      </Container>
    );
  }
);

CustomCheckbox.displayName = "CustomCheckbox";

export default CustomCheckbox;
